import { api, appPath } from '../api.js';
import { register, $, go } from '../ui.js';
import { stopQueue } from '../queue.js';

$('internal-sign-out-role').addEventListener('click', async () => {
  $('internal-sign-out-role').disabled = true;
  try {
    await api('/api/internal/logout', { method: 'POST', body: {} });
    stopQueue();
    go('access');
  } finally {
    $('internal-sign-out-role').disabled = false;
  }
});

register({ access: {
  enter() { stopQueue(); location.replace(appPath('/auth/login')); },
} });
